import { render } from "./App.vue?vue&type=template&id=0a1f076c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "../public/dashlite/scss/dashlite.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=0a1f076c&lang=scss"

import exportComponent from "/builds/juan_arzate/campestre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__